let lastTask = Promise.resolve()

export function enqueue<T>(task: () => Promise<T>): Promise<T> {
  // Chain this task after the last one
  const newTask = lastTask.then(task, task)

  // Update queue to wait for this task to finish
  lastTask = newTask.then(
    () => undefined,
    () => undefined
  )

  return newTask
}
